import React from 'react'
import "./OnBoarding.css";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { PROJECT_DISPLAY_NAME } from '../../../config/apiConfig';

export default function DomainPreferences() {
  return (
    <div className='domainpref_wrapper pt-4'>
      <div className='container'>
        <div className='row'>
        <div className='col-md-6 form_center text-center'>
            <div className='domainpref_form_block'>
            <h5 className='fill_info_head'>What do you need {PROJECT_DISPLAY_NAME} to help with?</h5>
              <p className='fill_info_para'>Select any applicable Industry your business may need helps us provide more personalised product recommendations</p>
              <Form name="information" className="domainpref_form_info mt-4">
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='domain_checkbox_block'>
                        <div className='icons_name_domain'>
                          <img src="/img/icons/onboarding/Aerospace.png" alt="logo"  className="icons_img" />
                          <p className='domain_text'>Aerospace</p>
                        </div>
                        <div className='checkbox_pref'>
                        <input type="checkbox" className='checkbox_co'/>
                        </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='domain_checkbox_block'>
                        <div className='icons_name_domain'>
                          <img src="/img/icons/onboarding/Chemicals.png" alt="logo"  className="icons_img" />
                          <p className='domain_text'>Chemicals</p>
                        </div>
                        <div className='checkbox_pref'>
                        <input type="checkbox" className='checkbox_co'/>
                        </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='domain_checkbox_block'>
                        <div className='icons_name_domain'>
                          <img src="/img/icons/onboarding/Energy.png" alt="logo"  className="icons_img" />
                          <p className='domain_text'>Energy</p>
                        </div>
                        <div className='checkbox_pref'>
                        <input type="checkbox" className='checkbox_co'/>
                        </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='domain_checkbox_block'>
                        <div className='icons_name_domain'>
                          <img src="/img/icons/onboarding/Healthcare.png" alt="logo"  className="icons_img" />
                          <p className='domain_text'>Healthcare</p>
                        </div>
                        <div className='checkbox_pref'>
                        <input type="checkbox" className='checkbox_co'/>
                        </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='domain_checkbox_block'>
                        <div className='icons_name_domain'>
                          <img src="/img/icons/onboarding/Packaging.png" alt="logo"  className="icons_img" />
                          <p className='domain_text'>Packaging, Construction</p>
                        </div>
                        <div className='checkbox_pref'>
                        <input type="checkbox" className='checkbox_co'/>
                        </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='domain_checkbox_block'>
                        <div className='icons_name_domain'>
                          <img src="/img/icons/onboarding/Transportation.png" alt="logo"  className="icons_img" />
                          <p className='domain_text'>Transportation</p>
                        </div>
                        <div className='checkbox_pref'>
                        <input type="checkbox" className='checkbox_co'/>
                        </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='domain_checkbox_block'>
                        <div className='icons_name_domain'>
                          <img src="/img/icons/onboarding/Aerospace.png" alt="logo"  className="icons_img" />
                          <p className='domain_text'>Banking</p>
                        </div>
                        <div className='checkbox_pref'>
                        <input type="checkbox" className='checkbox_co'/>
                        </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='domain_checkbox_block'>
                        <div className='icons_name_domain'>
                          <img src="/img/icons/onboarding/Banking.png" alt="logo"  className="icons_img" />
                          <p className='domain_text'>Food & Agri</p>
                        </div>
                        <div className='checkbox_pref'>
                        <input type="checkbox" className='checkbox_co'/>
                        </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='domain_checkbox_block'>
                        <div className='icons_name_domain'>
                          <img src="/img/icons/onboarding/InformationTechnology.png" alt="logo"  className="icons_img" />
                          <p className='domain_text'>Information Technology</p>
                        </div>
                        <div className='checkbox_pref'>
                        <input type="checkbox" className='checkbox_co'/>
                        </div>
                    </div>
                  </div>
                  <div className='clearfix'></div>
                  <div className='col-md-6'>
                    <div className='see_all_ind'>
                      <p className='see_all_para'>Select all Industries </p>
                      <input type="checkbox" className='checkbox_co'/>
                    </div>
                  </div>
                  <div className='col-md-12 mt-4'>
                    <div className='prev_next_block'>
                      <Button className="previous_btn">
                        Previous
                      </Button>
                      <Button className="next_btn">
                        Next <i className="fa fa-arrow-right" aria-hidden="true"></i>
                      </Button>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
        </div>
        </div>
      </div>
    </div>

  )
}
